import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '../../../../ms/oauth2/service/authentication.service';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent implements OnInit {
  currentUser: any;
  medicalStaffInfo: any = {
    firstname: '',
    lastname: '',
    email: '',
    gender: '',
    avatar: ''
  };

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.loadMedicalStaffInfo();
  }

  loadMedicalStaffInfo() {
    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser && currentUser.login) {
      this.http
        .get<any>(
          `/healthcare-facility-ms/api/v1/accounts-by-email?email=${currentUser.login}`
        )
        .subscribe(
          (data: any) => {
            this.medicalStaffInfo = {
              firstname: data.firstname || 'N/A',
              lastname: data.lastname || 'N/A',
              email: data.email || currentUser.login || 'N/A',
              gender: data.gender || 'N/A',
              avatar: data.avatar || 'assets/images/user/avatar-default.jpg'
            };
          },
          (error) => {
            console.error('Erreur lors de la récupération des infos medical staff:', error);
            this.medicalStaffInfo = {
              firstname: 'N/A',
              lastname: 'N/A',
              email: currentUser.login || 'N/A',
              gender: 'N/A',
              avatar: 'assets/images/user/avatar-default.jpg'
            };
          }
        );
    }
  }

  logout() {
    // Nettoyer la session de l'assistant
    localStorage.removeItem('pds_session_id');
    // Déconnexion de l'utilisateur
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }
}
